import React from 'react';
import styled from '@emotion/styled';

const SceneContainer = styled.div<{ marginBottom: number }>`
  max-width: 600px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
`;

const H1 = styled.h1`
  color: #292f36;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
`;

const H2 = styled.h2`
  margin-top: 10px;
  color: #7f8287;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
`;

const SceneHeading = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => (
  <SceneContainer marginBottom={!subtitle ? 80 : 40}>
    <H1 id="modalTitle">{title}</H1>
    {subtitle && <H2>{subtitle}</H2>}
  </SceneContainer>
);

export default SceneHeading;
